module.exports = __webpack_public_path__ + "media/images/icons/refresh-91424661ac80ec83e20ebcc2b62fb45b.svg";